// extracted by mini-css-extract-plugin
module.exports = {"container":"picture-list_container__2g1FS","isMiniImages":"picture-list_isMiniImages__1M9mX"};